import React, { useEffect, useState } from 'react';
import { FileSearch, Package } from 'lucide-react';
import { formatPedidoTimelineDateBr } from '../utils/orderDetailsModalUtils';
import { Odv2HoverTooltip } from './Odv2HoverTooltip';
import { OrderDetailsPedidoDetalheModal } from './OrderDetailsPedidoDetalheModal';

export function OrderDetailsPedidoPanel({ codigoPedido, pedido, statusAtual, loading, error, native = false }) {
  const cod = String(codigoPedido ?? '').trim();
  const [detalheOpen, setDetalheOpen] = useState(false);
  const [portalTarget, setPortalTarget] = useState(null);

  useEffect(() => {
    setDetalheOpen(false);
  }, [cod]);

  useEffect(() => {
    setPortalTarget(document.querySelector('.order-details-v2-modal'));
  }, []);

  return (
    <aside
      id="order-details-v2-pedido-panel"
      className="order-details-v2-col order-details-v2-col--pedido"
      aria-label="Informações do pedido"
    >
      <div className="order-details-v2-pedido-panel">
        <div className="order-details-v2-pedido-head order-details-v2-block-head">
          <h3 className="order-details-v2-block-title">
            <Package size={20} strokeWidth={2} aria-hidden />
            Informações do pedido
          </h3>
        </div>
        <div className="order-details-v2-pedido-body">
          {loading ? (
            <p className="order-details-v2-pedido-hint">Carregando…</p>
          ) : error ? (
            <p className="order-details-v2-pedido-error">{error}</p>
          ) : (
            <>
              <div className="order-details-v2-pedido-section">
                <div className="order-details-v2-pedido-section-label-row">
                  <span className="order-details-v2-field-label order-details-v2-field-label--caps">
                    Status atual
                  </span>
                  <button
                    type="button"
                    className={`order-details-v2-equip-historico-trigger${detalheOpen ? ' order-details-v2-equip-historico-trigger--active' : ''}`}
                    title="Ver detalhes"
                    aria-label="Ver detalhes"
                    aria-expanded={detalheOpen}
                    onClick={() => setDetalheOpen((v) => !v)}
                  >
                    <FileSearch size={14} strokeWidth={2} aria-hidden />
                    Ver detalhes
                  </button>
                </div>
                {statusAtual ? (
                  <div className="order-details-v2-pedido-status-line">
                    <div className="order-details-v2-pedido-status-main">
                      <span className="order-details-v2-pedido-status-code">
                        {String(statusAtual.TB02130_STATUS ?? '').trim() || '—'}
                      </span>
                      <span className="order-details-v2-pedido-status-name">
                        {String(statusAtual.TB02130_NOME ?? '').trim() || '—'}
                      </span>
                    </div>
                    <span className="order-details-v2-pedido-status-date">
                      {formatPedidoTimelineDateBr(statusAtual.TB02130_DATA)}
                    </span>
                  </div>
                ) : (
                  <p className="order-details-v2-pedido-hint">Sem linha do tempo.</p>
                )}
              </div>

              <div className="order-details-v2-pedido-section">
                <span className="order-details-v2-field-label order-details-v2-field-label--caps">
                  Produtos
                </span>
                {pedido?.produtos && pedido.produtos.length > 0 ? (
                  <div className="order-details-v2-pedido-table-wrap">
                    <table className="order-details-v2-pedido-table">
                      <thead>
                        <tr>
                          <th>Código</th>
                          <th>Ref.</th>
                          <th className="order-details-v2-pedido-th-qty">Qtd</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pedido.produtos.map((produto, index) => (
                          <tr key={`${cod}-${produto.codigo}-${index}`}>
                            <td className="order-details-v2-pedido-td-mono">{produto.codigo ?? '—'}</td>
                            <td>
                              <Odv2HoverTooltip
                                text={String(produto.nome ?? '').trim() || '—'}
                                placement="left"
                              >
                                <span className="order-details-v2-pedido-ref">
                                  {produto.referencia ?? '—'}
                                </span>
                              </Odv2HoverTooltip>
                            </td>
                            <td className="order-details-v2-pedido-td-qty">{produto.quantidade ?? '—'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="order-details-v2-pedido-hint">Nenhum produto.</p>
                )}
              </div>

              <div className="order-details-v2-pedido-section">
                <span className="order-details-v2-field-label order-details-v2-field-label--caps">
                  Observações
                </span>
                <textarea
                  className="order-details-v2-pedido-notes"
                  readOnly
                  rows={4}
                  value={String(pedido?.observacoes ?? '').trim() || 'Sem observações.'}
                />
              </div>
            </>
          )}
        </div>
      </div>

      <OrderDetailsPedidoDetalheModal
        open={detalheOpen}
        onClose={() => setDetalheOpen(false)}
        codigoPedido={cod}
        native={native}
        portalTarget={portalTarget}
      />
    </aside>
  );
}
